import "core-js/modules/es.array.push.js";
export default {
  computed: {
    token() {
      return this.$store.state.token;
    }
  },
  watch: {
    token(newVal) {
      this.getData();
    }
  },
  mounted() {
    // this.getData()
  },
  methods: {
    getData() {
      this.$api_tieling.getRainData().then(res => {
        let data1 = [];
        let data2 = [];
        let data3 = [];
        let data4 = [];
        let data5 = [];
        res.weatherHistoryList.map(i => {
          if (i.recordTime.slice(0, 4) == 2021) {
            data1.push(i.recordTime);
            data3.push(i.rainfall);
          } else if (i.recordTime.slice(0, 4) == 2022) {
            data2.push(i.recordTime);
            data4.push(i.rainfall);
          } else {
            data5.push(i.rainfall);
          }
        });
        this.initCharts(data1, data2, data3, data4, data5);
      });
    },
    initCharts(data1, data2, data3, data4, data5) {
      var chartDom = this.$refs.chart;
      var myChart = this.$echarts.init(chartDom);
      var option = {
        grid: {
          x: 60,
          x2: 20,
          y: 30,
          y2: 30
        },
        xAxis: {
          type: "category",
          data: ["1月", "2月", "3月", "4月", "5月", "6月"],
          axisLine: {
            lineStyle: {
              color: "#fff"
            }
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#fff"
            }
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            formatter: "{value} mm"
          }
        },
        legend: {
          data: ["2023", "2022"],
          textStyle: {
            color: "#fff"
          }
        },
        series: [{
          name: "2023",
          data: data5,
          type: "bar",
          // showBackground: true,
          backgroundStyle: {
            color: "#6CE1C0"
          },
          itemStyle: {
            normal: {
              color: "#6CE1C0",
              //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
              barBorderRadius: [5, 5, 2, 2]
            }
          }
        }, {
          name: "2022",
          data: data4,
          type: "bar",
          // showBackground: true,
          backgroundStyle: {
            color: "#74A3FE"
          },
          itemStyle: {
            normal: {
              color: "#74A3FE",
              //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
              barBorderRadius: [5, 5, 2, 2]
            }
          }
        }]
      };
      option && myChart.setOption(option);
    }
  }
};